// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"135":"78ddcaed","404":"8dfa6541","866":"2c468c1c","936":"1b2382ae","964":"5a01d772"}[chunkId] + ".chunk.css";
};